export const storeInSession = (key, value) => {
	sessionStorage.setItem(key, value);
};
export const retriveFromSession = (key) => {
	return sessionStorage.getItem(key);
};
export const deleteFromSession = (key) => {
	sessionStorage.removeItem(key);
};

export const storeCredentialsInSession = (universityCode, fairID, accessToken) => {
	sessionStorage.setItem("universityCode", universityCode);
	sessionStorage.setItem("fairID", fairID);
	sessionStorage.setItem("accessToken", accessToken);
};

export const checkAndGetCredentialsFromSession = () => {
	if (
		sessionStorage.getItem("universityCode") &&
		sessionStorage.getItem("fairID")
	) {
		return {
			universityCode: sessionStorage.getItem("universityCode"),
			fairID: sessionStorage.getItem("fairID"),
			accessToken: sessionStorage.getItem("accessToken"),
		};
	}
};

export const removeCredentialsFromSession = () => {
	sessionStorage.removeItem("universityCode");
	sessionStorage.removeItem("fairID");
	sessionStorage.removeItem("accessToken");
};
